import { useState } from "react";
import Loading from "../../components/Loading";
import Error from "../../components/Error";
import { format } from "date-fns";
import MonthChoice from "../../components/MonthChoice";
import AddButton from "../../components/AddButton";
import NewTestDialog from "./NewTestDialog";
import DrawTest from "./DrawTest";
import SelectFromList from "../../components/SelectFromList";
import useDBO from "../../hooks/useDBO";

export default function Tests() {
 
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [openNewTest, setOpenNewTest] = useState(false)
  const [testDate,setTestDate] = useState(new Date().tDate())
   const contacts = useDBO(`/marketing-contacts-tests/${year}/${month}`);


  if (contacts.loading) return <Loading />;
  if (contacts.error) return <Error />;
 

  let dates = [
    ...new Set(
      contacts
        .filter(
          (c) =>
            new Date(c.testDate).getFullYear() === year &&
            new Date(c.testDate).getMonth() === month
        )
        .map((c) => new Date(c.testDate).tDate())
    ),
  ];

  dates = dates.sort().reverse()
    
  const labels = dates.map((d) => ({ _id: d , name: `${format(new Date(d), "dd/MM")} (${contacts.filter(c => c.testDate && c.testDate.substring(0, 10) === d).length})` }));

  return (
    <div >
      <div style={{ display: "flex", gap:20, paddingBottom:20,marginBottom:20, borderBottom:"1px solid #ccc" }}>
      
        <MonthChoice
          year={year}
          setYear={setYear}
          month={month}
          setMonth={setMonth}
        />
        <SelectFromList choices={labels} value={testDate} setValue={setTestDate} size="small" style={{width:150}} />
        <AddButton
          tooltip="Add new test"
          action={() => setOpenNewTest(true)}
        />
        <NewTestDialog
          open={openNewTest}
          setOpen={setOpenNewTest}
          setContacts={contacts.set}
        />
      </div>
      <DrawTab testDate={testDate} contacts={contacts} />
    </div>
  );
}

function DrawTab(props) {
  const { contacts, testDate } = props;
  console.log(
    contacts.filter(
      (c) => c.testDate && c.testDate.substring(0, 10) === testDate
    )
  );
  return (
    <div>
  
      {contacts
        .filter((c) => c.testDate && c.testDate.substring(0,10) === testDate)
        .map((c) => (
          <DrawTest
            contact={c}
            key={c._id}
          />
        ))}
    </div>
  );
}
